import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Box,
  PageLayout,
  ActionList,
  ActionMenu,
  Button,
  ButtonGroup,
  Label,
} from "@primer/react";
import {
  PencilIcon,
  TrashIcon,
  PlusIcon,
  SyncIcon,
  KebabHorizontalIcon,
  ShareAndroidIcon,
  LinkIcon,
  TasklistIcon,
} from "@primer/octicons-react";
import Text from "../../../components/ui/text";

import { Dialog } from "@primer/react/drafts";
import { useSelector } from "react-redux";
import { useCommonContext } from "../../../contexts/common";
import { useCommonSelectedHook } from "../../../hooks/useCommonSelectedHook";
import { hocSinhNoiTruApi } from "../../../api/hocSinhNoiTruApi";
import { NotifyHelper } from "../../../helpers/toast";
import DataTable from "../../../components/ui/data-table";
import MyButton from "../../../components/ui/button/Button";
import { IHocSinhNoiTruItemResponse } from "../../../models/response/noi-tru/IHocSinhNoiTruItemResponse";
import UserAvatar from "../../../components/user-avatar";
import { ILopSelectedItemRequest } from "../../../models/request/danh-muc/ILopSelectedItemRequest";
import { ILopTreeViewItemResponse } from "../../../models/response/dm-lop/ILopTreeViewItemResponse";
import { lopApi } from "../../../api/lopApi";
import { PlaceHolder } from "../../../components/place-holder";
import LopHanhChinhTreeView from "../../../components/lop-hanh-chinh-treeview";
import moment from "moment";
import { RootState } from "../../../state/reducers";
import LopListContainer from "../../lop-hanh-chinh/lop-list-container";
import { ILopSelected } from "../../lop-hanh-chinh/LopHanhChinhPage";
import { dm_phong } from "../../../models/response/phong/dm_phong";
import { phongApi } from "../../../api/phongApi";
import PhongTreeView from "../../../components/phong-treeview";
import HocSinhNoiTruDetailModal from "../HocSinhNoiTruDetailModal";
import PhongDetailModal from "../phong/PhongDetailModal";
import ChuyenPhongDetailModal from "./ChuyenPhongDetailModal";
import XoaKhoiPhongModal from "./XoaKhoiPhongModal";

const PhongHocSinh: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [hocSinhNoiTrus, setHocSinhNoiTrus] = useState<
    IHocSinhNoiTruItemResponse[]
  >([]);
  const [selectedHocSinh, setSelectedHocSinh] =
    useState<IHocSinhNoiTruItemResponse | null>(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const { nam_hoc, dm_coso_id } = useCommonSelectedHook();
  const { status, treeViewItems } = useSelector(
    (x: RootState) => x.danhMucWrapper.lop
  );
  const [phongs, setPhongs] = useState<dm_phong[]>([]);
  const [selectedPhong, setSelectedPhong] = useState<{ phongId: number }>();
  const [filteredHocSinh, setFilteredHocSinh] = useState<
    IHocSinhNoiTruItemResponse[]
  >([]);
  const [selectedRoom, setSelectedRoom] = useState<string>("");
  const [danhSachHocSinhSlectedId, setDanhSachHocSinhSlectedId] = useState<
    number[]
  >([]);
  const [isShowModalChuyenPhong, setIsShowModalChuyenPhong] = useState(false);
  const [isShowXoaKhoiPhong, setIsShowXoaKhoiPhong] = useState(false);

  useEffect(() => {
    const loadPhongs = async () => {
      const res = await phongApi.selectAll();
      if (res.is_success) {
        setPhongs(res.data);
      }
    };
    loadPhongs();
  }, []);

  const [lopSelected, setLopSelected] = useState<ILopSelected>({
    dm_lop: {} as ILopSelectedItemRequest,
    ten_lop: "",
  });

  const loadHocSinhData = async () => {
    setIsLoading(true);
    try {
      const res = await hocSinhNoiTruApi.selectAll();
      if (res.is_success) {
        const filtered = res.data.filter(
          (x: IHocSinhNoiTruItemResponse) =>
            (!lopSelected.dm_lop.dm_truong_id ||
              x.dm_truong_id === lopSelected.dm_lop.dm_truong_id) &&
            (!lopSelected.dm_lop.dm_khoi_id ||
              x.dm_khoi_id === lopSelected.dm_lop.dm_khoi_id) &&
            (!lopSelected.dm_lop.dm_he_id ||
              x.dm_he_id === lopSelected.dm_lop.dm_he_id) &&
            (!lopSelected.dm_lop.dm_lop_id ||
              x.dm_lop_id === lopSelected.dm_lop.dm_lop_id)
        );
        setHocSinhNoiTrus(filtered);
      }
    } catch (error) {
      NotifyHelper.Error(translate("Error.LoadDataFailed"));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    loadHocSinhData();
  }, [lopSelected]);

  useEffect(() => {
    if (selectedPhong?.phongId) {
      if (selectedPhong.phongId === -1) {
        const filtered = hocSinhNoiTrus.filter(x => !x.dm_phong_id);
        setFilteredHocSinh(filtered);
      } else {
        const filtered = hocSinhNoiTrus.filter(x => x.dm_phong_id === selectedPhong.phongId);
        setFilteredHocSinh(filtered);
      }
    } else {
      setFilteredHocSinh([]);
    }
  }, [hocSinhNoiTrus, selectedPhong]);
  
  

  const { checkAccesiableTo, translate } = useCommonContext();

  const handleDelete = async (id: number) => {
    try {
      const res = await hocSinhNoiTruApi.delete(id);
      if (res.is_success) {
        await loadHocSinhData();
        NotifyHelper.Success(translate("Success.Delete"));
        setShowDeleteConfirm(false);
      } else {
        NotifyHelper.Error(res.message || translate("Error.DeleteFailed"));
      }
    } catch (error) {
      NotifyHelper.Error(translate("Error.Generic"));
    }
  };

  const handlePhongSelect = (phongId: number, ten_phong: string) => {
    setSelectedPhong({ phongId });
    setSelectedRoom(ten_phong);
    if (phongId === -1) {
      const filtered = hocSinhNoiTrus.filter((x) => !x.dm_phong_id);
      setFilteredHocSinh(filtered);
    } else if (phongId) {
      const filtered = hocSinhNoiTrus.filter((x) => x.dm_phong_id === phongId);
      setFilteredHocSinh(filtered);
    } else {
      setFilteredHocSinh([]);
    }
  };
  const onSelectionChanged = (selectedRowKeys: number[]) => {
    setDanhSachHocSinhSlectedId(selectedRowKeys);
  };
  const isAccessibleDelete = useMemo(() => {
    if (danhSachHocSinhSlectedId.length <= 0) return false;
    return true;
  }, [danhSachHocSinhSlectedId]);

  const isAccessibleUpdate = useMemo(() => {
    if (danhSachHocSinhSlectedId.length <= 0) return false;
    return true;
  }, [danhSachHocSinhSlectedId]);

  const handleReloadAsync = useCallback(async () => {
    await loadHocSinhData();
  }, []);

  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <Box
        sx={{
          pt: 3,
          width: "260px",
          flexShrink: 0,
        }}
      >
        <PhongTreeView
          dataSource={phongs}
          selectedValue={selectedPhong}
          onSelectionChanged={handlePhongSelect}
        />
      </Box>
      <Box sx={{ flex: 1, p: 3 }}>
        <DataTable
          height={`${window.innerHeight - 280}px`}
          data={filteredHocSinh}
          isLoading={isLoading}
          title={`Danh sách học sinh nội trú ${
            selectedRoom ? `- ${selectedRoom}` : ""
          }`}
          searchEnable
          paging={{ enable: true }}
          subTitle={`${translate("Base.Label.TotalCount")}: ${
            filteredHocSinh.length
          }`}
          actionComponent={
            <Box sx={{ display: "flex" }}>
              {/* <MyButton
                text="Base.Label.AddNew"
                leadingVisual={PlusIcon}
                size="medium"
                variant="primary"
                onClick={() => {
                  setSelectedHocSinh({ id: 0 } as IHocSinhNoiTruItemResponse);
                  setShowDetailModal(true);
                }}
                // apiAuthorized={`/${HOC_SINH_NOI_TRU_API}`}
                // apiAuthorizedMethod="POST"
              /> */}

              <ActionMenu>
                <ActionMenu.Button variant="primary">
                  <Text text="Base.Label.Command" />
                </ActionMenu.Button>
                <ActionMenu.Overlay width="auto">
                  <ActionList showDividers>
                    {/* <ActionList.Item
											onSelect={() => setIsShowModalSetClass(true)}
											disabled={!isAccessibleInsert}
										>
											<ActionList.LeadingVisual >
												<MultiSelectIcon />
											</ActionList.LeadingVisual>
											<Text text="HocSinhListContainer.Label.SubClass" />
										</ActionList.Item> */}
                    <ActionList.Item
                      onSelect={() => {
                        if (danhSachHocSinhSlectedId.length > 0) {
                          setIsShowModalChuyenPhong(true);
                        } else {
                          NotifyHelper.Warning("Vui lòng chọn học sinh trước");
                        }
                      }}
                      disabled={!isAccessibleUpdate}
                    >
                      <ActionList.LeadingVisual>
                        <TasklistIcon />
                      </ActionList.LeadingVisual>
                      <Text
                        text={`Chuyển phòng (${danhSachHocSinhSlectedId.length})`}
                      />
                    </ActionList.Item>

                    <ActionList.Item
                      onSelect={() => setIsShowXoaKhoiPhong(true)}
                      disabled={!isAccessibleDelete}
                      variant="danger"
                    >
                      <ActionList.LeadingVisual>
                        <TrashIcon />
                      </ActionList.LeadingVisual>
                      <Text text="Xóa khỏi phòng" />
                    </ActionList.Item>
                  </ActionList>
                </ActionMenu.Overlay>
              </ActionMenu>
              <MyButton
                text="Base.Label.Refresh"
                leadingVisual={SyncIcon}
                size="medium"
                sx={{ ml: 1 }}
                onClick={handleReloadAsync}
              />
            </Box>
          }
          selection={{
            mode: "multiple",
            keyExpr: "id",
            selectedRowKeys: danhSachHocSinhSlectedId,
            onSelectionChanged(keys) {
              onSelectionChanged(keys);
            },
          }}
          columns={[
            {
              dataField: "avatar",
              width: "100px",
              caption: translate("Avatar"),
              fixed: true,
              cellRender: (data: IHocSinhNoiTruItemResponse) => {
                return (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div style={{ color: "#10375C" }}>
                        <UserAvatar fullName={data.ho_ten} size="large" />
                      </div>
                    </div>
                  </Box>
                );
              },
            },
            {
              dataField: "ts_hocsinh_id",
              caption: translate("Học sinh"),
              cellRender: (data: IHocSinhNoiTruItemResponse) => (
                <Text text={data.ho_ten}></Text>
              ),
            },
            {
              dataField: "ts_hocsinh_noitru_status_id",
              caption: translate("Trạng thái"),
              cellRender: (data: IHocSinhNoiTruItemResponse) => (
                <Text text={data.trang_thai || ""}></Text>
              ),
            },
            {
              dataField: "thong_lop",
              caption: translate("Trường lớp"),
              cellRender: (data: IHocSinhNoiTruItemResponse) => {
                return (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "baseline",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div style={{ color: "#FF9D3D" }}>
                        <ShareAndroidIcon size={14} />
                      </div>
                      <span style={{ fontWeight: "500", marginLeft: "5px" }}>
                        {data.ten_truong} - {data.ten_khoi} - {data.ten_lop}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        paddingTop: "3px",
                      }}
                    >
                      <div style={{ color: "green" }}>
                        <LinkIcon size={14} />
                      </div>
                      <Label
                        style={{ marginLeft: "5px" }}
                        variant={
                          data.ten_he === "Bilingual Track"
                            ? "accent"
                            : data.ten_he === "International Track"
                            ? "success"
                            : "default"
                        }
                      >
                        {data.ten_he}
                      </Label>
                    </div>
                  </Box>
                );
              },
            },

            {
              dataField: "toa",
              // align:"center",
              caption: translate("Tòa"),
            },
            {
              dataField: "ten_phong",
              // align:"center",
              caption: translate("Phòng"),
            },
            {
              dataField: "ngay_bat_dau_o",
              align: "center",
              caption: translate("Ngày bắt đầu ở"),
              cellRender: (data: any) => {
                if (!data.ngay_bat_dau_o) return <span>-</span>;
                const date = moment.utc(data.ngay_bat_dau_o);
                return (
                  <span>
                    {date.isValid() ? date.format("DD/MM/YYYY") : "-"}
                  </span>
                );
              },
            },
            {
              dataField: "ghi_chu",
              caption: translate("Ghi chú"),
            },
            {
              id: "cmd",
              caption: "",
              width: "50px",
              align: "center",
              cellRender: (data: IHocSinhNoiTruItemResponse) => (
                <ActionMenu>
                  <ActionMenu.Button
                    icon={KebabHorizontalIcon}
                    variant="invisible"
                    sx={{ m: -1 }}
                  >
                    &nbsp;
                  </ActionMenu.Button>
                  <ActionMenu.Overlay width="auto">
                    <ActionList>
                      <ActionList.Item
                        onSelect={() => {
                          setSelectedHocSinh(data);
                          setShowDetailModal(true);
                        }}
                      >
                        <ActionList.LeadingVisual>
                          <PencilIcon />
                        </ActionList.LeadingVisual>
                        {translate("Base.Label.Edit")}
                      </ActionList.Item>
                      <ActionList.Item
                        variant="danger"
                        onSelect={() => {
                          setSelectedHocSinh(data);
                          setShowDeleteConfirm(true);
                        }}
                      >
                        <ActionList.LeadingVisual>
                          <TrashIcon />
                        </ActionList.LeadingVisual>
                        {translate("Base.Label.Delete")}
                      </ActionList.Item>
                    </ActionList>
                  </ActionMenu.Overlay>
                </ActionMenu>
              ),
            },
          ]}
        />
        {isShowModalChuyenPhong && (
          <ChuyenPhongDetailModal
            selectedIds={danhSachHocSinhSlectedId}
            onClose={() => setIsShowModalChuyenPhong(false)}
            onSuccess={() => {
              setIsShowModalChuyenPhong(false);
              handleReloadAsync(); // Tải lại dữ liệu
            }}
          />
        )}
        {isShowXoaKhoiPhong && (
          <XoaKhoiPhongModal
            selectedIds={danhSachHocSinhSlectedId}
            onClose={() => setIsShowXoaKhoiPhong(false)}
            onSuccess={() => {
              setIsShowXoaKhoiPhong(false);
              handleReloadAsync(); // Tải lại dữ liệu
            }}
          />
        )}

        {showDetailModal && selectedHocSinh && (
          <HocSinhNoiTruDetailModal
            id={selectedHocSinh.id}
            onCancel={() => setShowDetailModal(false)}
            onSuccess={() => {
              setShowDetailModal(false);
              handleReloadAsync();
            }}
          />
        )}

        {showDeleteConfirm && selectedHocSinh && (
          <Dialog
            title={translate("Base.Label.Confirm")}
            onClose={() => setShowDeleteConfirm(false)}
          >
            <Dialog.Body>{translate("Base.Message.DeleteConfirm")}</Dialog.Body>
            <Dialog.Footer>
              <Button onClick={() => setShowDeleteConfirm(false)}>
                {translate("Base.Label.Cancel")}
              </Button>
              <Button
                variant="danger"
                onClick={() => handleDelete(selectedHocSinh.id)}
              >
                {translate("Base.Label.Delete")}
              </Button>
            </Dialog.Footer>
          </Dialog>
        )}
      </Box>{" "}
    </Box>
  );
};

export default PhongHocSinh;
